import {closestNumber} from '@helpers/utils';
import {Component} from '@lib/Component';
import {sharedComponent} from '@lib/utils';
import {createApplicationState} from '@services/ApplicationState';
import {IApplicationState} from '@services/types';

const RATIO = 0.0;
const PRE_RATIO = 0.1;
const THRESHOLD = [RATIO, PRE_RATIO];

@sharedComponent
export default class FirstView extends Component {
  private appState: IApplicationState = createApplicationState();
  private prev = 0;
  private observer: IntersectionObserver | null = null;

  didMount() {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const isUpScroll = this.prev < entry.intersectionRatio;
          // MEMO: target elementがwindow.heightより大きいとIntersectionObserverがバグる
          const r = closestNumber(THRESHOLD, entry.intersectionRatio);
          const isPreDown = !isUpScroll && r === PRE_RATIO;
          const isPreUp = isUpScroll && r === PRE_RATIO;
          const isDown = !isUpScroll && r === RATIO;
          const isUp = isUpScroll && r === RATIO;

          if (isUp) {
            this.upScrolled();
          }
          if (isDown) {
            this.downScrolled();
          }
          if (isPreUp) {
            this.preUpScrolled();
          }
          if (isPreDown) {
            this.preDownScrolled();
          }

          this.prev = entry.intersectionRatio;
        }
      },
      {
        threshold: THRESHOLD,
        // rootMargin: '0px'
      },
    );
    this.element && this.observer.observe(this.element);
  }

  private preUpScrolled() {
    this.appState.updateFirstViewScrollStatus('inView');
  }

  private preDownScrolled() {
    // FIXME:
  }

  private upScrolled() {
    this.appState.updateFirstViewScrollStatus('inView');
  }

  private downScrolled() {
    this.appState.updateFirstViewScrollStatus('scrolled');
  }
}
